import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

class CombinedTextField extends React.Component {
  state = {
    isFocused: false,
  };

  handleFocus = () => {
    this.setState({
      isFocused: true,
    });
  };

  handleBlur = () => {
    this.setState({
      isFocused: false,
    });
  };

  render() {
    const { children } = this.props;
    const { isFocused } = this.state;
    const classNames = isFocused ? 'combined-text-field is-focused' : 'combined-text-field';

    return (
      <div className={classNames} onFocus={this.handleFocus} onBlur={this.handleBlur}>
        {children}
      </div>
    );
  }
}

CombinedTextField.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CombinedTextField;
